import { Skeleton, styled } from '@mui/material';

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
	backgroundColor: theme.palette.grey['100'],
	borderRadius: '5px',
	'& .wide': {
		width: '100%',
	},
	'& .margin-1': {
		margin: '5px',
	},
	'& .margin-2': {
		margin: '10px',
	},
}));

export const StyledSkeletonRecentOrders = styled(Skeleton)(({ theme }) => ({
	backgroundColor: theme.palette.grey['100'],
	borderRadius: '0',
	'& .wide': {
		width: '100%',
	},
	'& .margin-1': {
		margin: '5px',
	},
	'& .margin-2': {
		margin: '10px',
	},
}));
